import React from 'react';
import { Link } from 'react-router-dom';
import harmonyHealthLogo from '../../src/img/harmonyhealth.png';

const links = [
  {
    to: '29dc6a0e-bfe8-4c7c-bf67-3188b3e0a695',
    label: 'м. Київ, вул. Б. Чибінєєвих, 8Д'
  },
  {
    to: '61e567b3-3ada-4892-b86e-677b04511d22',
    label: 'м. Київ, вул. В. Чорновола, 12'
  },
  {
    to: '020c9628-933e-4d46-8577-3cc95eada9d1',
    label: 'Репродуктологія, вул. В. Чорновола, 12'
  },
  {
    to: '3ba602c8-b318-4204-95ec-1ea46c3ede97',
    label: 'м. Київ, вул. Дніпровська наб., 15Ж'
  },
  {
    to: '7d0597cf-1d25-48d3-ab12-e4844e880984',
    label: 'м. Київ, вул. О. Кониського, 45-49'
  },
  {
    to: '1962e122-1c9e-4448-9031-6cfa66edd533',
    label: 'м. Київ, вул. О. Пчілки, 2'
  },
  {
    to: 'e9d702a4-89c0-4ceb-b06e-d27317a71033',
    label: 'м. Київ, вул. О. Пчілки, 4'
  },
  {
    to: 'c6638025-4819-4656-9dab-3de7870e297a',
    label: 'м. Київ, вул. Ревуцького, 40 В'
  },
  {
    to: 'ee37c28c-af3a-43ff-a8cd-99cb60ce0e4d',
    label: 'м. Київ, вул. Причальна, 8'
  }
];

const HarmonyHealthPage = () => {
  return (
    <div className="page__inner">
      <div className="harmonyhealth">
        <div className="harmonyhealth__container">
          <div className="harmonyhealth__header">
            <img src={harmonyHealthLogo} alt="harmonyhealth" />
          </div>
          <div className="harmonyhealth__text">
            <p className="harmonyhealth__textFirstRow">
              Будь ласка, оцініть свій візит!
            </p>
            <p>Виберіть локацію обслуговування 👇</p>
          </div>
          <div className="harmonyhealth__buttons-containers">
            {links.map((item, index) => {
              return (
                <Link key={index} to={`/device/vote/${item.to}`}>
                  <button className="harmonyhealth__button">
                    {item.label}
                  </button>
                </Link>
              );
            })}
          </div>
          <div className="harmonyhealth__footer">
            <p style={{ color: '#42423e' }}>
              Розроблено в &nbsp;
              <a href="https://liketo.me/" target="_blank" rel="noreferrer">
                liketo.me
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HarmonyHealthPage;
